document.addEventListener("DOMContentLoaded", function () {
  var stockBox = document.getElementById("variant-stock");

  function updateStock(variantId) {
    var qty = window.variantInventory[variantId] || 0;
    if (qty > 0) {
      stockBox.innerHTML = `In Stock ${qty}`;
      stockBox.style.color = "green";
    } else {
      stockBox.innerHTML = "Out of Stock";
      stockBox.style.color = "red";
    }
  }

  var variantSelector = document.querySelector('[name="id"]');

  if (variantSelector) {
    updateStock(variantSelector.value);

    variantSelector.addEventListener("change", function () {
      updateStock(this.value);
    });
  }
});
